import React, { useEffect, useState } from 'react';
import classes from "./SubscriptionPage.module.css";
import axios from 'axios';
import { useNavigate, useSearchParams } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { getHeaderEnrichmentApi, getIPApi, getTokenApi, loginApi, printLogsApi, subscribeApi } from '../http/http';
import { FaCopyright } from 'react-icons/fa6';
import Loader from '../components/Player/UI/Loader/Loader';
import Spinner from '../components/Player/UI/Loader/Spinner';

const SubscriptionPage = () => {
    const [headerMsisdn, setHeaderMsisdn] = useState(null);
    const [loading, setLoading] = useState(true);
    const [subscribeLoading, setSubscribeLoading] = useState(false);
    const [error, setError] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const [extRef, setExtRef] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (Cookies.get("msisdn")) {
            navigate("/home");
        }
    }, []);

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const getToken = async () => {
        try {
            setLoading(true);
            const response = await axios.post(getTokenApi);
            console.log(response, 'response...');
            fetchMsisdn(response?.data?.token);
            // after getting the token hit the getMsisdn api....
        } catch (error) {
            setLoading(false);
            setError(true);
            console.log(error, 'error');
        }
    }

    const fetchMsisdn = async (token) => {
        try {

            const response = await axios.get(
                getHeaderEnrichmentApi,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // "X-App": "he-partner",
                        // "X-MessageID": "1234",
                        // "X-Source-System": "he-partner",
                    },
                }
            );

            console.log("Response Data:", response.data);

            const {
                Authorization,
                'Content-Type': contentType,
                'X-App': xApp,
                'X-Source-System': xSourceSystem,
                'x-messageid': xMessageId,
                url,
            } = response.data?.body;

            const secondResponse = await axios.get(url, {
                headers: {
                    Authorization,
                    'Content-Type': contentType,
                    'X-App': xApp,
                    'X-Source-System': xSourceSystem,
                    'x-messageid': xMessageId,
                },
            });

            console.log("MSISDN Response:", secondResponse.data);

            let numberFromHeader = secondResponse?.data?.ServiceResponse?.ResponseBody?.Response?.Msisdn;
            // if (numberFromHeader) {
            //     setHeaderMsisdn(numberFromHeader);
            // }

            const response2 = await axios.post(printLogsApi, {
                apiResponse: response.data,
                apiResponse2: JSON.stringify(secondResponse.data)
            });

            console.log(response2, 'respons2...');

            if (numberFromHeader) {
                setHeaderMsisdn(numberFromHeader);
                await handleLogin(numberFromHeader);
            }

            setLoading(false);
            setError(false);

        } catch (error) {
            setLoading(false);
            setError(true);
            console.error("API Error:", error);
            const response2 = await axios.post(printLogsApi, {
                apiError: error?.response?.data?.header ?? error
            });
            console.log(response2, 'response')
        }
    }

    const handleSubscription = async () => {
        try {
            if (headerMsisdn?.trim().length > 0) {

                setSubscribeLoading(true);

                const responseIP = await axios.get(getIPApi);
                const response = await axios.post(subscribeApi, {
                    msisdn: headerMsisdn,
                    ext_ref: extRef,
                    ip_address: responseIP?.data?.ip
                });

                console.log(response, 'response...');

                const response2 = await axios.post(printLogsApi, {
                    apiRequest: {
                        msisdn: headerMsisdn,
                        ext_ref: extRef,
                        ip_address: responseIP?.data?.ip
                    },
                    apiResponse: JSON.stringify(JSON.stringify(response.data)),
                });
                console.log(response2, 'respons2...');

                let message = response?.data?.result?.message;
                let result = response?.data?.result;
                
                if (message == "User Already Exist" || result == 2) {
                    Cookies.set('msisdn', headerMsisdn, { expires: 1 });
                    navigate("/home");
                    return;
                }

                setSubscribeLoading(false);

                let redirect_url = response?.data?.result?.cg_url;
                if (redirect_url) {
                    window.location.href = redirect_url
                }
                else {
                    toast.error('Redirect url not found!');
                }

            }
            else {
                toast.error("Failure in subscription, Due to invalid msisdn from Header Enrichment!");
                return;
            }

        } catch (error) {
            console.log(error, 'error---');
            setSubscribeLoading(false);
            toast.error(error?.response?.data?.message || error?.response?.message || "Something Went Wrong!");
        }
    }

    const handleLogin = async (henumber) => {
        try {
            const response = await axios.post(loginApi, {
                msisdn: henumber,
                ext_ref: extRef,
            });

            console.log(response, 'response...');
            setLoading(false);
            Cookies.set('msisdn', henumber, { expires: 1 });
            navigate("/home");
        } catch (error) {
            console.log(error, 'error---');
        }
    }

    useEffect(() => {
        getToken();
    }, []);
    return (
        <>
            <main className={classes.main}>
                <header className={classes.header}>
                    <nav className={classes.nav}>
                        <div className={classes.logo_container}>
                            <img src="/assets/images/logo.png" alt="logo" className={classes.logo} />
                        </div>
                    </nav>
                </header>


                <section className={classes.section_landing_page}>
                    <div className={classes.grid_container}>
                        <div className={classes.grid_section_one}>
                            <form className={classes.form}>

                                <div className={classes.landingPageBanner}>
                                    <img src="assets/images/banner.png" alt="Banner" className={classes.banner} />
                                </div>

                                {!loading && error ? (
                                    <div className={classes.alert}>
                                        <p className={classes.alert_text}>Something Went Wrong! Please Refresh the Page and Try Again!</p>
                                    </div>
                                ) : !loading && headerMsisdn ?
                                    (
                                        <>
                                            <button type="button"
                                                disabled={subscribeLoading}
                                                className={classes.login_btn}
                                                onClick={handleSubscription}
                                            >
                                                {
                                                    subscribeLoading ? "Please Wait..." : "Subscribe"
                                                }
                                            </button>
                                            <p className={classes.subscriptionChargeText}>Subscription KSH 15/Day</p>
                                        </>

                                    )
                                    : !loading && !headerMsisdn ? (
                                        <div className={classes.alert}>
                                            <p className={classes.alert_text}>Turn off Wifi and Switch to Safaricom Network to Subscribe the Service.</p>
                                        </div>
                                    ) : null
                                }

                                <div className={classes.grid_or_container}>
                                    <span className={classes.grid_item}></span>
                                    <span className={classes.or}>Or</span>
                                    <span className={classes.grid_item}></span>
                                </div>

                                <button className={classes.loginLink} onClick={() => navigate(`/login?ext_id=${extRef}`)}>
                                    Already a Subscriber, Login
                                </button>

                            </form>


                            <div className={classes.termsSection}>
                                <h1 className={classes.termsHeading}>Terms & Conditions</h1>
                                <ul className={classes.termsList}>
                                    <li>The service cost is KSH 15/day.</li>
                                    <li>Your Subscription will be renewed at KSH 15/day, automatically until you unsubscribe.</li>
                                    <li>You can unsubscribe from the service anytime, by dialling USSD code *xxx# or deactivating from the portal.</li>
                                    <li>All data-enabled features & Smartphone users can enjoy full service.</li>
                                    <li>Customer can access the content at any time during the subscription validity period.</li>
                                </ul>
                            </div>

                        </div>
                        <div className={classes.grid_section_two}>
                            <img src="/assets/images/kids-group.png" alt="kids-group" className={classes.kids_group_image} />


                            <p className={classes.portal_description}>
                                Online educational platform for digital skills where students aged between 2-10 learn through fun and interactive videos
                            </p>

                            <div className={classes.grid_sub_container}>
                                <div className={classes.kids_image_container}>
                                    <img src="/assets/images/kids.png" alt="kids" className={classes.kids_image} />
                                </div>
                                <div className={classes.kids_info}>
                                    <p className={classes.kids_info_text_one}>Made For</p>
                                    <p className={classes.kids_info_text_two}>- Kids</p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <img src="/assets/images/Union.png" alt="union" className={classes.union_image} />
                    <img src="/assets/images/learning.png" alt="union" className={classes.learning_image} />

                </section>

                <section className={classes.footer}>
                    <div className={classes.container}>
                        <div className={classes.footer_container}>
                            <div className={classes.footer_logo_container}>
                                <img src="/assets/images/logo.png" alt="logo" className={classes.footer_logo} />
                            </div>

                            <div className={classes.copyright_container}>
                                <FaCopyright className={classes.copyright_icon} />
                                <p className={classes.copyright_text}>
                                    Rainboo Softmate Pvt Ltd
                                </p>
                            </div>
                        </div>


                    </div>
                </section>

            </main>
            {loading &&
                <div className={classes.full_screen_loader_container}>
                    <Spinner />
                    <p className={classes.loader_text}>Loading Please Wait...</p>
                </div>
            }
        </>
    )
}

export default SubscriptionPage;